/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */

'use es6';

export default class Context {
  constructor(doc, nav, scr, win, loc, top_, parent_) {
    this.doc = doc || document;
    this.nav = nav || navigator;
    this.scr = scr || screen;
    this.win = win || window;
    this.loc = loc || this.win.location;
    this.top = top_;
    this.parent = parent_;
  }
  getDocument() {
    return this.doc;
  }
  getNavigator() {
    return this.nav;
  }
  getScreen() {
    return this.scr;
  }
  getWindow() {
    return this.win;
  }
  getLocation() {
    return this.loc;
  }
  getHostName() {
    try {
      return this.loc.hostname;
    } catch (e) {
      return this.doc.domain;
    }
  }
  getPathName() {
    return this.loc.pathname;
  }
  getTop() {
    return this.top;
  }
  getParent() {
    return this.parent;
  }
  getReferrer() {
    let referrer = '';
    try {
      referrer = this.top.document.referrer;
    } catch (e) {
      if (this.parent) {
        try {
          referrer = this.parent.document.referrer;
        } catch (e2) {
          referrer = '';
        }
      }
    }
    if (referrer === '') {
      referrer = this.doc.referrer;
    }
    return referrer;
  }
  getCharacterSet() {
    return this.doc.characterSet ? this.doc.characterSet : this.doc.charset ? this.doc.charset : '';
  }
  getLanguage() {
    return this.nav.language ? this.nav.language : this.nav.browserLanguage ? this.nav.browserLanguage : '';
  }
  getOrigin() {
    const origin = this.loc.origin;
    if (origin) {
      return origin;
    }
    const port = this.loc.port ? `:${this.loc.port}` : '';
    return `${this.loc.protocol}//${this.getHostName()}${port}`;
  }
  getCurrentHref(pathOverride) {
    return pathOverride ? this.getOrigin().toLowerCase() + pathOverride : this.loc.href.toLowerCase();
  }
}